<div class="sidenav">
  <img
    class="app-logo"
    ngSrc="./assets/logo.svg"
    priority
    height="40"
    alt="Paystashio"
    width="201" />
  <div class="overflow-container">
    @if (!isLoading) {
      <div class="top-nav">
        <div class="nav nav-pills flex-column">
          @for (item of navItems(); track item.id) {
            @if (item.children) {
              <div
                class="nav-item nav-item-btn"
                [ngClass]="{ 'collapsed': collapseState[item.id] }">
                <button
                  class="nav-link"
                  (click)="toggleCollapse(item.id)"
                  [attr.aria-expanded]="!collapseState[item.id]"
                  [disabled]="!hasNavigationAccess()">
                  <span class="sidenav-icon">
                    <i [ngClass]="item.iconClass"></i>
                  </span>
                  {{ item.label }}
                  @if (item.needsPremiumAccess && !item.hasPremiumAccess) {
                    <i class="pays-svg-icon ic-crown"></i>
                  }
                  <i class="iconoir-nav-arrow-right ms-auto"></i>
                </button>
              </div>
              <div
                class="nav-items-nested"
                [ngbCollapse]="collapseState[item.id]">
                <div class="d-flex flex-column ms-1">
                  @for (child of item.children; track child.routerLink) {
                    <div class="nav-item">
                      @if (hasNavigationAccess()) {
                        <a
                          [routerLink]="child.routerLink"
                          routerLinkActive="active"
                          class="nav-link"
                          (click)="onCloseSideNav()">
                          {{ child.label }}
                          @if (child.needsPremiumAccess && !child.hasPremiumAccess) {
                            <i class="pays-svg-icon ic-crown"></i>
                          }
                        </a>
                      } @else {
                        <div class="nav-link disabled">
                          {{ child.label }}
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            } @else {
              <div class="nav-item">
                @if (hasNavigationAccess() || item.id === 'dashboard') {
                  <a
                    [routerLink]="item.routerLink"
                    routerLinkActive="active"
                    class="nav-link"
                    (click)="onCloseSideNav()">
                    <span class="sidenav-icon">
                      <i [ngClass]="item.iconClass"></i>
                    </span>
                    {{ item.label }}
                  </a>
                } @else {
                  <div class="nav-link disabled">
                    <span class="sidenav-icon">
                      <i [ngClass]="item.iconClass"></i>
                    </span>
                    {{ item.label }}
                  </div>
                }
              </div>
            }
          }
        </div>
        <hr />
      </div>
    } @else {
      <div class="nav nav-pills flex-column">
        @for (item of _baseNavItems; track item.id) {
          <div class="nav-item">
            <div class="nav-link disabled">
              <span class="sidenav-icon">
                <i [ngClass]="item.iconClass"></i>
              </span>
              {{ item.label }}
            </div>
          </div>
        }
      </div>
    }
    <!-- Bottom navigation -->
    <div class="bottom-nav mt-auto">
      <hr />
      <div class="nav nav-pills flex-column">
        <div class="nav-item tutorial-link">
          <button
            (click)="onOpenTutorial()"
            class="nav-link">
            <span class="sidenav-icon">
              <i class="iconoir-info-circle"></i>
            </span>
            Onboarding guide
          </button>
        </div>
        <div
          class="nav-item nav-item-btn"
          [ngClass]="{ 'collapsed': helpCollapsed }">
          <button
            class="nav-link"
            (click)="helpCollapse.toggle()"
            [attr.aria-expanded]="!helpCollapsed"
            aria-controls="helpCollapseMenu">
            <span class="sidenav-icon">
              <i class="iconoir-help-circle"></i>
            </span>
            Help center
            <i class="iconoir-nav-arrow-right ms-auto"></i>
          </button>
        </div>
        <div
          class="nav-items-nested"
          #helpCollapse="ngbCollapse"
          [(ngbCollapse)]="helpCollapsed">
          <div class="d-flex flex-column ms-1">
            @if (hasNavigationAccess()) {
              <div class="nav-item">
                <a
                  routerLink="help-center/faq"
                  routerLinkActive="active"
                  class="nav-link"
                  (click)="onCloseSideNav()">
                  FAQs
                </a>
              </div>
              <div class="nav-item">
                <a
                  routerLink="help-center/how-to-videos"
                  routerLinkActive="active"
                  class="nav-link"
                  (click)="onCloseSideNav()">
                  How to videos
                </a>
              </div>
            }
            <div class="nav-item">
              <a
                target="_blank"
                id="btnContactHelpCenter"
                rel="noopener"
                [href]="helpCenterUrl"
                class="nav-link"
                (click)="onCloseSideNav()">
                Get support
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<button
  class="side-nav-overlay"
  (click)="onSideNavToggleClicked()"
  id="toggle_side_nav_overlay">
  &nbsp;
</button>
